@if (menuItems$ | async; as menuItems) {
  <ds-dropdown
    [ds-tooltip]="'profile' | translate"
    [tooltipPlacement]="DsTooltipPosition.bottom"
    [placement]="['bottom-end', 'top-end']"
    data-test-id="profile-dropdown"
    [selectedValue]="(activeMenuItem$ | async)?.id"
  >
    @if (isVerticalNavigationEnabled()) {
      <ng-container>
        <ds-dropdown-toggle
          [buttonClass]="'d-flex align-items-center justify-content-center top-nav-profile-button'"
          [iconClass]="'d-flex align-items-center justify-content-center profile-icon'"
          [ariaLabel]="'profile' | translate"
          [variant]="DsButtonVariants.microAction"
          [icon]="Icons.User"
        >
        </ds-dropdown-toggle>
      </ng-container>
    } @else {
      <ds-dropdown-toggle [icon]="Icons.User" [variant]="DsButtonVariants.microAction" [ariaLabel]="'profile' | translate">
      </ds-dropdown-toggle>
    }
    <div ds-dropdown-menu>
      @for (menuItem of menuItems; track menuItem.id) {
        <ds-dropdown-item
          [value]="menuItem.id"
          [label]="menuItem.label | translate"
          [icon]="menuItem.iconName"
          [href]="menuItem.routerLink"
          (selected)="menuItem.onClick ? menuItem.onClick() : null"
        >
        </ds-dropdown-item>
      }
    </div>
  </ds-dropdown>
}
